/** Primary header navigation. `to` values map to file-based routes. */
export interface NavItem {
  label: string
  to: string
}

export const MAIN_NAV: readonly NavItem[] = [
  { label: 'Chat', to: '/chat' },
  { label: 'Agent Orchestration', to: '/' },
  { label: 'Audit Trail', to: '/audit-trail' },
  { label: 'Configuration', to: '/configuration' },
]
